export const INFO_TEXT: string =
  'Изменения вступят в силу, после того как вы нажмете кнопку «Сохранить изменения»';
export const FORM_SUCCESS_MESSAGE: string = 'Изменения сохранены!';
export const FORM_ERROR_MESSAGE: string = 'Изменения не сохранены!';
export const FORM_ERROR_MESSAGE_FIELDS: string =
  'Изменения не сохранены! Неоходимо заполнить обязательные поля во всех разделах.';
export const INTERESTS_ERRORS = ['competences', 'professions'];
export const GLOBAL_ERRORS = ['email'];



// WEBPACK FOOTER //
// ./src/pages/profile/views/settings/consts.ts